import LazyLoadImages from "../events/ImageLoaded";
import LabModal from "../components/LabModal";

export default class ArchiveProjectDetailed {
    static init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.start());
        } else {
            this.start();
        }
    }

    static start() {
        LabModal.init();

        this.form = document.getElementById('lab-filters');
        this.container = document.getElementById('projects-container');
        this.searchInput = document.getElementById('lab-search');
        this.searchCross = document.querySelector('.search-input-cross');
        this.headerFilterBtn = document.querySelector('.menu-item-filter');
        this.headerSearchBtn = document.querySelector('.menu-item-search');
        
        if (!this.form || !this.container) {
            console.warn('ArchiveProjectDetailed: Formulaire ou Grille introuvable.');
            return;
        }

        this.resetButton = document.getElementById('reset-lab-filters');
        this.maxPages = parseInt(this.form.dataset.maxPages || 1);
        this.ajaxUrl = window.location.href.split('?')[0];

        this.page = 1;
        this.loading = false;
        this.finished = false;
        this.timeout = null;

        console.log('✅ ArchiveProjectDetailed: Initialisé.');

        this.updateFilterCount();
        this.updateSearchState();
        this.bindEvents();
        this.initProjectTagsOverflow();
        this.updateProjectTagsOverflow();
        this.initInfiniteScroll();
    }

    static bindEvents() {
        const filterButtons = this.form.querySelectorAll('.btn-filter');
        filterButtons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                btn.classList.toggle('selected');
                this.updateFilterCount();
                this.resetAndLoad();
            });
        });

        if (this.searchInput) {
            this.searchInput.addEventListener('input', () => {
                clearTimeout(this.timeout);
                this.toggleCrossVisibility();
                this.updateSearchState();
                this.timeout = setTimeout(() => this.resetAndLoad(), 500);
            });
            this.toggleCrossVisibility();
        }

        if (this.searchCross && this.searchInput) {
            this.searchCross.addEventListener('click', () => {
                this.searchInput.value = '';
                this.toggleCrossVisibility();
                this.updateSearchState();
                this.resetAndLoad();
                this.searchInput.focus();
            });
        }

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.resetAndLoad();
        });

        if (this.resetButton) {
            this.resetButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.form.querySelectorAll('.btn-filter.selected').forEach(btn => btn.classList.remove('selected'));
                this.updateFilterCount();
                this.resetAndLoad();
            });
        }

        window.addEventListener('popstate', () => window.location.reload());
    }

    static initProjectTagsOverflow() {
        if (this.tagsOverflowInitialized) return;
        this.tagsOverflowInitialized = true;
        this.tagsOverflowRaf = null;

        window.addEventListener('resize', () => {
            if (this.tagsOverflowRaf) cancelAnimationFrame(this.tagsOverflowRaf);
            this.tagsOverflowRaf = requestAnimationFrame(() => this.updateProjectTagsOverflow());
        });
    }

    static updateProjectTagsOverflow(scope = document) {
        const rows = scope.querySelectorAll('.js-project-tags-row');
        rows.forEach((row) => {
            const tags = Array.from(row.querySelectorAll('.js-project-domain-tag'));
            if (!tags.length) return;

            const existingOverflowTag = row.querySelector('.js-project-tags-overflow');
            if (existingOverflowTag) existingOverflowTag.remove();

            tags.forEach((tag) => { tag.style.display = ''; });

            const firstTop = tags[0].offsetTop;
            let overflowStartIndex = -1;

            for (let i = 0; i < tags.length; i++) {
                if (tags[i].offsetTop > firstTop) {
                    overflowStartIndex = i;
                    break;
                }
            }

            if (overflowStartIndex === -1) return;

            let hiddenCount = tags.length - overflowStartIndex;
            for (let i = overflowStartIndex; i < tags.length; i++) {
                tags[i].style.display = 'none';
            }

            const overflowTag = document.createElement('span');
            overflowTag.className = 'tag tag-outline text-uppercase col-auto js-project-tags-overflow';
            overflowTag.textContent = `+${hiddenCount}`;
            row.appendChild(overflowTag);

            while (overflowStartIndex > 0 && overflowTag.offsetTop > firstTop) {
                overflowStartIndex--;
                tags[overflowStartIndex].style.display = 'none';
                hiddenCount++;
                overflowTag.textContent = `+${hiddenCount}`;
            }
        });
    }

    static updateSearchState() {
        if (!this.headerSearchBtn || !this.searchInput) return;
        if (this.searchInput.value.trim() !== '') {
            this.headerSearchBtn.classList.add('has-search');
        } else {
            this.headerSearchBtn.classList.remove('has-search');
        }
    }

    static updateFilterCount() {
        const count = this.form.querySelectorAll('.btn-filter.selected').length;

        if (this.headerFilterBtn) {
            if (count > 0) {
                this.headerFilterBtn.classList.add('has-filters');
            } else {
                this.headerFilterBtn.classList.remove('has-filters');
            }

            let text = 'Filtres';
            if (count === 1) text = '1 filtre';
            else if (count > 1) text = `${count} filtres`;

            this.headerFilterBtn.innerHTML = `<span>${text}</span>`;
        }

        if (this.resetButton) {
            this.resetButton.hidden = count === 0;
        }
    }

    static toggleCrossVisibility() {
        if (this.searchCross && this.searchInput) {
            if (this.searchInput.value.trim() !== '') {
                this.searchCross.style.display = 'block';
                this.searchCross.style.opacity = '1';
                this.searchCross.style.cursor = 'pointer';
            } else {
                this.searchCross.style.display = 'none';
            }
        }
    }

    static initInfiniteScroll() {
        const sentinel = document.getElementById('infinite-scroll-sentinel');
        if (!sentinel) return;

        this.maxPages = parseInt(sentinel.dataset.maxPages || this.maxPages || 1);

        this.observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && !this.loading && !this.finished && this.page < this.maxPages) {
                this.loadMore();
            }
        }, {rootMargin: '200px'});

        this.observer.observe(sentinel);
    }

    static resetAndLoad() {
        this.page = 1;
        this.finished = false;
        this.container.style.opacity = '0.5';
        this.fetchProjects(true);
    }

    static loadMore() {
        this.fetchProjects(false);
    }

    static fetchProjects(reset = false) {
        if (this.loading || (!reset && this.finished)) return;

        this.loading = true;
        const loader = document.getElementById('infinite-scroll-loader');
        if (loader) loader.style.display = 'block';

        const formData = new FormData(this.form);

        const activeFilters = this.form.querySelectorAll('.btn-filter.selected');
        activeFilters.forEach(btn => {
            const parentWrapper = btn.closest('[data-name]');
            if (parentWrapper) {
                formData.append(parentWrapper.dataset.name, btn.dataset.value);
            }
        });

        if (this.searchInput && this.searchInput.value.trim() !== '') {
            formData.set('search', this.searchInput.value.trim());
        } else {
            formData.delete('search');
        }

        formData.append('ajax', '1');
        const nextPage = reset ? 1 : this.page + 1;
        formData.append('ajax_paged', nextPage);

        if (reset) {
            this.updateURL(formData);
        }

        const url = new URL(this.ajaxUrl, window.location.origin);
        for (const [key, value] of formData.entries()) {
            url.searchParams.append(key, value);
        }

        fetch(url.toString(), {
            method: 'GET',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
            .then(response => {
                if (!response.ok) throw new Error('Erreur serveur: ' + response.status);
                return response.text();
            })
            .then(responseText => {
                const jsonStartIndex = responseText.indexOf('{');
                const jsonEndIndex = responseText.lastIndexOf('}');
                if (jsonStartIndex === -1 || jsonEndIndex === -1) throw new Error('Aucun JSON trouvé');
                const jsonString = responseText.substring(jsonStartIndex, jsonEndIndex + 1);
                return JSON.parse(jsonString);
            })
            .then(data => {
                if (data.success) {
                    this.container.style.opacity = '1';

                    if (reset) {
                        this.container.innerHTML = data.html;
                        this.page = 1;
                        if (this.observer) {
                            this.observer.disconnect();
                            this.initInfiniteScroll();
                        }
                    } else {
                        const parser = new DOMParser();
                        const htmlDoc = parser.parseFromString(data.html, 'text/html');
                        const newItems = htmlDoc.querySelectorAll('.project_detailed-card');
                        const currentGrid = this.container.querySelector('#projects-grid');

                        if (currentGrid && newItems.length > 0) {
                            newItems.forEach(item => {
                                const postId = item.dataset.id;
                                if (postId && this.container.querySelector(`.project_detailed-card[data-id="${postId}"]`)) {
                                    return;
                                }

                                const column = item.closest('[class*="col-"]');
                                if(column) currentGrid.appendChild(column);
                            });
                        }

                        const oldSentinel = document.getElementById('infinite-scroll-sentinel');
                        const oldLoader = document.getElementById('infinite-scroll-loader');
                        if (oldSentinel) oldSentinel.remove();
                        if (oldLoader) oldLoader.remove();

                        const newSentinel = htmlDoc.getElementById('infinite-scroll-sentinel');
                        const newLoader = htmlDoc.getElementById('infinite-scroll-loader');
                        
                        if (newSentinel) {
                            this.container.appendChild(newSentinel);
                            if (this.observer) this.observer.observe(newSentinel);
                        }
                        if (newLoader) this.container.appendChild(newLoader);

                        this.page++;
                    }

                    this.updateProjectTagsOverflow(this.container);

                    if (data.pagination_info) {
                        this.maxPages = parseInt(data.pagination_info.max_num_pages);
                        const countEl = document.getElementById('results-count');
                        if (countEl && data.pagination_info.total_posts !== undefined) {
                            countEl.innerText = `${data.pagination_info.total_posts} projets`;
                        }
                    }

                    this.finished = (this.page >= this.maxPages);
                    const sentinel = document.getElementById('infinite-scroll-sentinel');
                    if (sentinel) sentinel.style.display = this.finished ? 'none' : 'block';

                    setTimeout(() => {
                        if (LazyLoadImages && typeof LazyLoadImages.init === 'function') {
                            LazyLoadImages.init();
                        }
                    }, 100);
                }
            })
            .catch(error => {
                console.error('Erreur AJAX:', error);
                this.container.style.opacity = '1';
            })
            .finally(() => {
                this.loading = false;
                if (loader) loader.style.display = 'none';
            });
    }

    static updateURL(formData) {
        const urlParams = new URLSearchParams();
        for (const [key, value] of formData.entries()) {
            if (!['ajax', 'action', 'nonce', 'paged', 'max_pages'].includes(key) && value !== '') {
                urlParams.append(key, value);
            }
        }
        const queryString = urlParams.toString();
        const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
        window.history.pushState({ path: newUrl }, '', newUrl);
    }
}
